
async function getCartData() {
  try {
    const response = await fetch("/cart.json");
    if (!response.ok) throw new Error("Network response was not ok");
    return await response.json();
  } catch (error) {
    throw (console.error("Error getting cart data:", error), error);
  }
}
async function CustomaddToCart(variantId, quantity, selling_plan) {
  var formData = {
    items: [{ id: variantId, quantity, selling_plan: selling_plan }],
  };
  fetch(window.Shopify.routes.root + "cart/add.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(formData),
  })
    .then((response) => {
      if (!response.ok) throw new Error("Network response was not ok");
      return response.json();
    })
    .then((cartData) => {
      getCartData()
        .then((data) => {
          updateCartInfo(data, ".cart-item-loop");
        })
        .catch((error) => {
          console.error("Error getting cart data:", error);
        });
    })
    .catch((error) => {
      console.error("Error:", error);
    })
    .finally(() => {
      $(".mini-cart").addClass("show");
      $(".mm-fullscreen-bg").addClass("active");
      cartBodyHeightCalc();
      $("body").addClass("hidden");
    });
}
async function addItemFromForm() {
  let addToCartForm = document.querySelector('form[action$="/cart/add"]'),
    formData = new FormData(addToCartForm);
  fetch(window.Shopify.routes.root + "cart/add.js", {
    method: "POST",
    body: formData,
  })
    .then((response) => {
      if (!response.ok) throw new Error("Network response was not ok");
      return response.json();
    })
    .then((cartData) => {
      getCartData()
        .then((data) => {
          updateCartInfo(data, ".cart-item-loop");
        })
        .catch((error) => {
          console.error("Error getting cart data:", error);
        });
    })
    .catch((error) => {
      console.error("Error:", error);
    });
}
function updateCartInfo(cart, cartCellId) {
  const { attributes = {}, items, total_price, item_count } = cart,
    mealsCount = countLunchAndDinnerMeals(items),
    orderType = attributes.orderType ?? "WeeklySubscription",
    formatMoney = "<span class='money'>\u20B9</span>";
  if (typeof cartCellId != "string") {
    console.error("Invalid cartCellId provided");
    return;
  }
  const cartCell = jQuery(cartCellId);
  if (!cartCell.length) {
    console.error("No cart cell found for the provided ID");
    return;
  }
  cartCell.empty();
  let totalPrice = 0;
  if (items && items.length > 0) {
    jQuery(".cart-item-loop, .cart-item-title, .subtotal-title-area").show(),
      jQuery(".cart-tempty-title").hide();
    const table = jQuery(cartCellId);
    items.forEach(
      ({
        price,
        quantity,
        url,
        image,
        title,
        variant_id,
        product_type,
        id,
      }) => {
        let priceHTML = "",
          comparePriceHTML = "";
        if (orderType === "OneTimePurchase") {
          let discount = 0;
          mealsCount >= oneTimeOffers.promo3.mealRange.max
            ? (discount = oneTimeOffers.promo3.discounts)
            : mealsCount >= oneTimeOffers.promo2.mealRange.max
            ? (discount = oneTimeOffers.promo2.discounts)
            : mealsCount >= oneTimeOffers.promo1.mealRange.max &&
              (discount = oneTimeOffers.promo1.discounts);
          const actualPrice = price * quantity;
          if (
            userLoggedIn &&
            Array.isArray(customerData.tags) &&
            customerData.tags.includes("NDIS") &&
            typeof customerData.ndisDiscountPercentage == "number"
          ) {
            let subscriptionPrice =
              price * quantity * (1 - customerData.ndisDiscountPercentage);
            (totalPrice += subscriptionPrice),
              (comparePriceHTML = `<span class="compare-price-cart text-decoration-line-through fs-14">${Shopify.formatMoney(
                actualPrice,
                ""
              )}</span>`),
              (priceHTML = `<span class="price-cart fw-bold fs-16">${Shopify.formatMoney(
                subscriptionPrice,
                ""
              )}</span>`);
          } else if (product_type === "LUNCH & DINNER" && discount > 0) {
            const discountedPrice =
              actualPrice - (actualPrice * discount) / 100;
            (totalPrice += discountedPrice),
              (comparePriceHTML = `<span class="compare-price-cart text-decoration-line-through fs-14">${Shopify.formatMoney(
                actualPrice,
                ""
              )}</span>`),
              (priceHTML = `<span class="price-cart fw-bold fs-16">${Shopify.formatMoney(
                discountedPrice,
                ""
              )}</span>`);
          } else
            (totalPrice += actualPrice),
              (comparePriceHTML = `<span class="price-cart fw-bold fs-16">${Shopify.formatMoney(
                actualPrice,
                ""
              )}</span>`);
        }
        const listItem = `
                <li class="cart-item d-flex">
                    <div class="cart-image position-relative w-15 border rounded">
                        <a href="${url}">
                            <img src="${image}" alt="${title}" class="img-fluid">
                        </a>
                        <span class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-orange px-2 py-1">${quantity}</span>
                    </div>
                    <div class="cart-title d-flex flex-column w-75 ms-3">
                        <a href="${url}">${title.substring(0, 50)}</a>
                        <div class="cart-pro-info">
                            <div class="cart-qty-price">
                                <span class="quantity-${id} d-none">${quantity}</span>
                                <span class="price-box">
                                    ${priceHTML}
                                     ${comparePriceHTML}
                                </span>
                            </div>
                            <div class="product-quantity-action mt-2 gap-3">
                                <div class="product-quantity" data-variant="${id}">
                                    <div class="cart-plus-minus">
                                        <div class="dec qtybutton" data-action="-"><i class="icon-minus fw-bolder"></i></div>
                                        <input value="${quantity}" type="text" class="qtyinputcs" name="quantity" min="1" pattern="[0-9]*">
                                        <span class="cusqtyspan quantity-${id}">${quantity}</span>
                                        <div class="inc qtybutton" data-action="+"><i class="icon-plus fw-bolder"></i></div>
                                    </div>
                                </div>
                                <span class="cart-loading load-anim"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M304 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm0 416a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM48 304a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm464-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM142.9 437A48 48 0 1 0 75 369.1 48 48 0 1 0 142.9 437zm0-294.2A48 48 0 1 0 75 75a48 48 0 1 0 67.9 67.9zM369.1 437A48 48 0 1 0 437 369.1 48 48 0 1 0 369.1 437z"/></svg></span>
                                <div class="delete-item-cart">
                                    <a class="remove_from_cart" href="javascript:void(0);" onclick="changeInToCart(${variant_id}, 0)">
                                        <i class="icon-trash icons"></i>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </li>
            `;
        table.append(listItem);
      }
    );
  } else
    jQuery(".cart-item-loop, .cart-item-title, .subtotal-title-area").hide(),
      jQuery(".cart-tempty-title").show();
  document.querySelectorAll(".total-discount-amount").forEach((el) => {
    el.textContent = "";
  }),
    document.querySelectorAll(".total-price-amount").forEach((el) => {
      el.textContent = `${Shopify.formatMoney(totalPrice, "")}`;
    });
  const cartCounter = jQuery(".bigcounter");
  cartCounter.html(item_count).addClass("added-cart-event"),
    setTimeout(() => cartCounter.removeClass("added-cart-event"), 2e3),
    jQuery(".currency .active").trigger("click");
  const res = generateOfferDOM(cart);
}
function clearCartData() {
  return fetch(window.Shopify.routes.root + "cart/clear.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
  })
    .then((response) => {
      if (!response.ok) throw new Error("Network response was not ok");
      return response.json();
    })
    .then((clearCart) => {
      updateCartInfo(clearCart, ".cart-item-loop"),
        localStorage.removeItem("contractInfo"),
        (window.location.href = "/collections/fresh-ready-meals");
    })
    .catch((error) => {
      throw (console.error("Error clearing cart:", error), error);
    });
}

var updateTimeout;
$(document).off("click", ".qtybutton").on("click", ".qtybutton", function (e) {
  e.preventDefault(); // Prevent default action
  
  clearTimeout(updateTimeout);
  
  var $button = $(this),
      action = $button.data("action"),
      $quantitySpan = $button.siblings(".cusqtyspan"),
      $quantityInput = $button.siblings("input"),
      oldValue = parseInt($quantitySpan.text(), 10),
      newVal = oldValue;

  if (action === "+") {
    newVal = oldValue + 1;
  } else if (action === "-" && oldValue > 1) {
    newVal = oldValue - 1;
  }

  // Update UI with new value
  $quantitySpan.text(newVal);
  $quantityInput.val(newVal);

  var $productQuantityAction = $button.closest(".product-quantity-action"),
      variantId = $button.closest(".product-quantity").data("variant");

  updateTimeout = setTimeout(function () {
    changeInToCart(variantId, newVal, $quantitySpan, $productQuantityAction);
  }, 500);
  var formatMoney = "<span class='money'></span>";
});

function changeInToCart(
  variantId,
  quantity,
  quantityElement = null,
  $productQuantityAction = null
) {
  $productQuantityAction?.addClass("loading"),
    $.ajax({
      type: "POST",
      url: "/cart/change.js",
      dataType: "json",
      data: { quantity, id: variantId },
      success: function (data) {
        getCartData()
          .then((data2) => {
            updateCartInfo(data2, ".cart-item-loop");
          })
          .catch((error) => {
            console.error("Error getting cart data:", error);
          }),
          $productQuantityAction?.removeClass("loading");
      },
      error: function (error) {
        console.error("Error adding to cart: ", error),
          quantityElement &&
            quantityElement.text(quantityElement.data("original-value")),
          $productQuantityAction?.removeClass("loading");
      },
    });
}
//# sourceMappingURL=/cdn/shop/t/135/assets/custom-cart-ajax.js.map
